module.exports = __webpack_public_path__ + "img/how-it-works2.628acfb6.svg";